<template>
  <div class="card box-shadow-low rounded-0 border-0 py-3 px-2" style="max-width: 720px; margin: 0 auto">
                    <div class="card-header bg-white d-flex align-items-center border-0">
                        <div class="mr-auto">
                            <div class="d-flex align-items-center">
                                <router-link
                                  tag="h2"
                                  :to="'/'"
                                  class="bg-secondary fa-arrow-left m-0 mr-2 p-2 text-primary cursor-pointer"
                                  style="font-size: 14px">
                                </router-link>
                                <div class="d-flex align-items-center">
                                    <h2 class="m-0 font-weight-bold">$1,500-$1,750</h2>
                                    <h3 class="m-0 text-grey pl-2">(5h 30m)</h3>
                                </div>
                            </div>
                            <h5 class="m-0 mt-2 text-grey">Estimated Price for <span class="text-primary font-weight-bold">3 man crew</span> & <span class="text-primary font-weight-bold">1 truck</span></h5>
                        </div>

                        <router-link
                          tag="button"
                          :to="'confirmation'"
                          class="btn btn-success font-weight-bold px-4">
                          Confirm Booking
                        </router-link>
                    </div>
                    <hr class="separator" />
                    <div class="card-body bg-white">
                        <h3 class="text-center text-grey mb-4">Available Move Times</h3>
                        <div class="row">
                            <div class="col-sm">
                                <h3 class="m-0 text-center">Thursday 20th <span class="text-grey">$</span></h3>
                                <div class="options mt-3">
                                    <div class="form-check mb-2">
                                        <input type="checkbox" class="form-check-input" id="20-8-9">
                                        <label class="form-check-label" for="20-8-9">8am - 9am</label>
                                    </div>
                                    <div class="form-check mb-2 not-available">
                                        <input type="checkbox" class="form-check-input" id="20-10-12">
                                        <label class="form-check-label" for="20-10-12">10am - 12pm</label>
                                    </div>
                                    <div class="form-check mb-2">
                                        <input type="checkbox" class="form-check-input" id="20-1-3">
                                        <label class="form-check-label" for="20-1-3">1pm - 3pm</label>
                                    </div>
                                    <div class="form-check mb-2">
                                        <input type="checkbox" class="form-check-input" id="20-4-6">
                                        <label class="form-check-label" for="20-4-6">4pm - 6pm</label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm">
                                <h3 class="m-0 text-center">Friday 21st <span class="text-grey">$</span></h3>
                                <div class="options mt-3">
                                    <div class="form-check mb-2 not-available">
                                        <input type="checkbox" class="form-check-input" id="21-8-9">
                                        <label class="form-check-label" for="21-8-9">8am - 9am</label>
                                    </div>
                                    <div class="form-check mb-2">
                                        <input type="checkbox" class="form-check-input" id="21-10-12">
                                        <label class="form-check-label" for="21-10-12">10am - 12pm</label>
                                    </div>
                                    <div class="form-check mb-2 not-available">
                                        <input type="checkbox" class="form-check-input" id="21-1-3">
                                        <label class="form-check-label" for="21-1-3">1pm - 3pm</label>
                                    </div>
                                    <div class="form-check mb-2">
                                        <input type="checkbox" class="form-check-input" id="21-4-6">
                                        <label class="form-check-label" for="21-4-6">4pm - 6pm</label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm">
                                <h3 class="m-0 text-center">Saturday 22nd <span class="text-grey">$</span></h3>
                                <div class="options mt-3">
                                    <div class="form-check mb-2">
                                        <input type="checkbox" class="form-check-input" id="22-8-9">
                                        <label class="form-check-label" for="22-8-9">8am - 9am</label>
                                    </div>
                                    <div class="form-check mb-2">
                                        <input type="checkbox" class="form-check-input" id="22-10-12">
                                        <label class="form-check-label" for="22-10-12">10am - 12pm</label>
                                    </div>
                                    <div class="form-check mb-2 not-available">
                                        <input type="checkbox" class="form-check-input" id="22-1-3">
                                        <label class="form-check-label" for="22-1-3">1pm - 3pm</label>
                                    </div>
                                    <div class="form-check mb-2 not-available">
                                        <input type="checkbox" class="form-check-input" id="22-4-6">
                                        <label class="form-check-label" for="22-4-6">4pm - 6pm</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr class="separator" />
                    <div class="card-footer bg-white border-0">
                        <h5 class="font-weight-bold">How do we calculate the estimate?</h5>
                        <div class="small text-grey">Nullam fringilla, tortor ut fermentum molestie, lorem orci pretium dolor, sit amet rhoncus enim turpis ac metus. Donec fringilla dapibus turpis vitae faucibus. Cras lacinia mattis odio quis accumsan. Phasellus ac efficitur enim, in scelerisque odio. Morbi sollicitudin massa at lorem vehicula, ac interdum orci consectetur. Vestibulum sodales blandit eleifend. Phasellus vitae magna libero. Nunc nec laoreet enim.</div>
                    </div>
                </div>
</template>

<script>
export default {
  name: 'available-times',
};
</script>

<style lang="scss">

.form-check {
  width: auto;
  padding: 0 !important;
  input[type='checkbox'] {
    display: none;
    ~ label {
      cursor: pointer;
      font-size: 15px;
      color: #777777;
      position: relative;
      width: 100%;
      padding: 10px 15px;
      color: #444444;
      background-color: #fff;
      border: 1px solid #146dc0;
      border-radius: 2px;
      font-size: 16px;
      text-align: center;
      transition: all 300ms ease-out;
      &:before, &:after {
        content: none;
      }
      // &:before {
      //   content: '';
      //   position: absolute;
      //   width: 20px;
      //   height: 20px;
      //   right: 0;
      //   background: #fff;
      //   top: 0;
      //   border-radius: 3px;
      //   border: 1px solid #d8d8d8;
      // }
      // &:after {
      //   content: '';
      //   width: 14px;
      //   height: 14px;
      //   position: absolute;
      //   right: 3px;
      //   top: 3px;
      //   border-radius: 3px;
      //   background: transparent;
      //   transform: scale(0.8);
      //   transition: all 200ms ease-out;
      // }
    }
    &:checked ~ label {
      background-color: #146dc0;
      border-color: #146dc0;
      color: #fff;
      // &:after {
      //   transform: scale(1);
      //   background: #146dc0;
      // }
    }
  }
  &.not-available {
    opacity: 0.5;
    pointer-events: none;
     label {
      text-decoration: line-through;
    }
  }
}
</style>
